/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ExportQuoteGroupData,
  ImportQuoteGroupData,
  PostQuoteTestExecutionCommentBody,
  PostQuoteTestExpectationBody,
  PostQuoteTestGroupBody,
  PostQuoteTestPermutationGroupBody,
  PostQuoteTestScenarioBody,
  PostXmlToJson,
  QuoteTestExecutionComment,
  QuoteTestExecutionType,
  QuoteTestGroup,
  QuoteTestGroupDto,
  QuoteTestScenario,
  QuoteTestScenarioDetailsDto,
  Shipment,
  XmlToJson,
} from "../models/index";
import {
  ExportQuoteGroupDataFromJSON,
  ExportQuoteGroupDataToJSON,
  ImportQuoteGroupDataFromJSON,
  ImportQuoteGroupDataToJSON,
  PostQuoteTestExecutionCommentBodyFromJSON,
  PostQuoteTestExecutionCommentBodyToJSON,
  PostQuoteTestExpectationBodyFromJSON,
  PostQuoteTestExpectationBodyToJSON,
  PostQuoteTestGroupBodyFromJSON,
  PostQuoteTestGroupBodyToJSON,
  PostQuoteTestPermutationGroupBodyFromJSON,
  PostQuoteTestPermutationGroupBodyToJSON,
  PostQuoteTestScenarioBodyFromJSON,
  PostQuoteTestScenarioBodyToJSON,
  PostXmlToJsonFromJSON,
  PostXmlToJsonToJSON,
  QuoteTestExecutionCommentFromJSON,
  QuoteTestExecutionCommentToJSON,
  QuoteTestExecutionTypeFromJSON,
  QuoteTestExecutionTypeToJSON,
  QuoteTestGroupFromJSON,
  QuoteTestGroupToJSON,
  QuoteTestGroupDtoFromJSON,
  QuoteTestGroupDtoToJSON,
  QuoteTestScenarioFromJSON,
  QuoteTestScenarioToJSON,
  QuoteTestScenarioDetailsDtoFromJSON,
  QuoteTestScenarioDetailsDtoToJSON,
  ShipmentFromJSON,
  ShipmentToJSON,
  XmlToJsonFromJSON,
  XmlToJsonToJSON,
} from "../models/index";

export interface CloneGroupRequest {
  groupId: string;
  carrierIdentifier: string;
  serviceIdentifier: string;
}

export interface CloneScenarioRequest {
  scenarioId: string;
  groupId: string;
}

export interface CreateCommentRequest {
  postQuoteTestExecutionCommentBody: PostQuoteTestExecutionCommentBody;
}

export interface CreateGroupRequest {
  postQuoteTestGroupBody: PostQuoteTestGroupBody;
}

export interface CreateGroupExpectationRequest {
  groupId: string;
  postQuoteTestExpectationBody: PostQuoteTestExpectationBody;
}

export interface CreatePermutationGroupRequest {
  postQuoteTestPermutationGroupBody: PostQuoteTestPermutationGroupBody;
}

export interface CreateScenarioRequest {
  groupId: string;
  postQuoteTestScenarioBody: PostQuoteTestScenarioBody;
}

export interface CreateScenarioFromShipmentIdRequest {
  shipmentId: string;
  groupId: string;
}

export interface CreateScenarioFromShipmentJsonRequest {
  groupId: string;
  shipment: Shipment;
}

export interface CreteScenarioExpectationRequest {
  scenarioId: string;
  postQuoteTestExpectationBody: PostQuoteTestExpectationBody;
}

export interface DeleteCommentRequest {
  commentId: string;
}

export interface DeleteExpectationRequest {
  expectationId: string;
}

export interface DeleteGroupRequest {
  groupId: string;
}

export interface DeleteScenarioRequest {
  scenarioId: string;
}

export interface ExportDataRequest {
  groupId: string;
}

export interface GetAllGroupsRequest {
  carrierIdentifier: string;
  serviceIdentifier: string;
}

export interface GetScenarioRequest {
  scenarioId: string;
}

export interface ImportDataRequest {
  importQuoteGroupData: ImportQuoteGroupData;
}

export interface RunGroupRequest {
  groupId: string;
  executionType: QuoteTestExecutionType;
  tags: Array<string>;
}

export interface RunScenarioRequest {
  scenarioId: string;
  executionType: QuoteTestExecutionType;
  tags: Array<string>;
}

export interface UpdateCommentRequest {
  quoteTestExecutionComment: QuoteTestExecutionComment;
}

export interface UpdateGroupRequest {
  quoteTestGroup: QuoteTestGroup;
}

export interface UpdateScenarioRequest {
  quoteTestScenario: QuoteTestScenario;
}

export interface XmlToJsonRequest {
  postXmlToJson: PostXmlToJson;
}

/**
 *
 */
export class QuoteTestApi extends runtime.BaseAPI {
  /**
   */
  async cloneGroupRaw(
    requestParameters: CloneGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling cloneGroup().',
      );
    }

    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling cloneGroup().',
      );
    }

    if (requestParameters["serviceIdentifier"] == null) {
      throw new runtime.RequiredError(
        "serviceIdentifier",
        'Required parameter "serviceIdentifier" was null or undefined when calling cloneGroup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["serviceIdentifier"] != null) {
      queryParameters["serviceIdentifier"] =
        requestParameters["serviceIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/clone-group`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async cloneGroup(
    requestParameters: CloneGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.cloneGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async cloneScenarioRaw(
    requestParameters: CloneScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["scenarioId"] == null) {
      throw new runtime.RequiredError(
        "scenarioId",
        'Required parameter "scenarioId" was null or undefined when calling cloneScenario().',
      );
    }

    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling cloneScenario().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["scenarioId"] != null) {
      queryParameters["scenarioId"] = requestParameters["scenarioId"];
    }

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/clone-scenario`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async cloneScenario(
    requestParameters: CloneScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.cloneScenarioRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createCommentRaw(
    requestParameters: CreateCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["postQuoteTestExecutionCommentBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestExecutionCommentBody",
        'Required parameter "postQuoteTestExecutionCommentBody" was null or undefined when calling createComment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/comments`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestExecutionCommentBodyToJSON(
          requestParameters["postQuoteTestExecutionCommentBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createComment(
    requestParameters: CreateCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createCommentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createGroupRaw(
    requestParameters: CreateGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["postQuoteTestGroupBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestGroupBody",
        'Required parameter "postQuoteTestGroupBody" was null or undefined when calling createGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestGroupBodyToJSON(
          requestParameters["postQuoteTestGroupBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createGroup(
    requestParameters: CreateGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createGroupExpectationRaw(
    requestParameters: CreateGroupExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling createGroupExpectation().',
      );
    }

    if (requestParameters["postQuoteTestExpectationBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestExpectationBody",
        'Required parameter "postQuoteTestExpectationBody" was null or undefined when calling createGroupExpectation().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups/{groupId}/expectations`.replace(
          `{${"groupId"}}`,
          encodeURIComponent(String(requestParameters["groupId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestExpectationBodyToJSON(
          requestParameters["postQuoteTestExpectationBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createGroupExpectation(
    requestParameters: CreateGroupExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createGroupExpectationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createPermutationGroupRaw(
    requestParameters: CreatePermutationGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["postQuoteTestPermutationGroupBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestPermutationGroupBody",
        'Required parameter "postQuoteTestPermutationGroupBody" was null or undefined when calling createPermutationGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups/permutations`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestPermutationGroupBodyToJSON(
          requestParameters["postQuoteTestPermutationGroupBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createPermutationGroup(
    requestParameters: CreatePermutationGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createPermutationGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createScenarioRaw(
    requestParameters: CreateScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling createScenario().',
      );
    }

    if (requestParameters["postQuoteTestScenarioBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestScenarioBody",
        'Required parameter "postQuoteTestScenarioBody" was null or undefined when calling createScenario().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups/{groupId}/scenarios`.replace(
          `{${"groupId"}}`,
          encodeURIComponent(String(requestParameters["groupId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestScenarioBodyToJSON(
          requestParameters["postQuoteTestScenarioBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createScenario(
    requestParameters: CreateScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createScenarioRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createScenarioFromShipmentIdRaw(
    requestParameters: CreateScenarioFromShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling createScenarioFromShipmentId().',
      );
    }

    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling createScenarioFromShipmentId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/create-from-shipment-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createScenarioFromShipmentId(
    requestParameters: CreateScenarioFromShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createScenarioFromShipmentIdRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async createScenarioFromShipmentJsonRaw(
    requestParameters: CreateScenarioFromShipmentJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling createScenarioFromShipmentJson().',
      );
    }

    if (requestParameters["shipment"] == null) {
      throw new runtime.RequiredError(
        "shipment",
        'Required parameter "shipment" was null or undefined when calling createScenarioFromShipmentJson().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/create-from-shipment-json`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ShipmentToJSON(requestParameters["shipment"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createScenarioFromShipmentJson(
    requestParameters: CreateScenarioFromShipmentJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createScenarioFromShipmentJsonRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async creteScenarioExpectationRaw(
    requestParameters: CreteScenarioExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["scenarioId"] == null) {
      throw new runtime.RequiredError(
        "scenarioId",
        'Required parameter "scenarioId" was null or undefined when calling creteScenarioExpectation().',
      );
    }

    if (requestParameters["postQuoteTestExpectationBody"] == null) {
      throw new runtime.RequiredError(
        "postQuoteTestExpectationBody",
        'Required parameter "postQuoteTestExpectationBody" was null or undefined when calling creteScenarioExpectation().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/{scenarioId}/expectations`.replace(
          `{${"scenarioId"}}`,
          encodeURIComponent(String(requestParameters["scenarioId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostQuoteTestExpectationBodyToJSON(
          requestParameters["postQuoteTestExpectationBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async creteScenarioExpectation(
    requestParameters: CreteScenarioExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.creteScenarioExpectationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteCommentRaw(
    requestParameters: DeleteCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["commentId"] == null) {
      throw new runtime.RequiredError(
        "commentId",
        'Required parameter "commentId" was null or undefined when calling deleteComment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/comments/{commentId}`.replace(
          `{${"commentId"}}`,
          encodeURIComponent(String(requestParameters["commentId"])),
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteComment(
    requestParameters: DeleteCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCommentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteExpectationRaw(
    requestParameters: DeleteExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["expectationId"] == null) {
      throw new runtime.RequiredError(
        "expectationId",
        'Required parameter "expectationId" was null or undefined when calling deleteExpectation().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/expectations/{expectationId}`.replace(
          `{${"expectationId"}}`,
          encodeURIComponent(String(requestParameters["expectationId"])),
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteExpectation(
    requestParameters: DeleteExpectationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteExpectationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteGroupRaw(
    requestParameters: DeleteGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling deleteGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups/{groupId}`.replace(
          `{${"groupId"}}`,
          encodeURIComponent(String(requestParameters["groupId"])),
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteGroup(
    requestParameters: DeleteGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteScenarioRaw(
    requestParameters: DeleteScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["scenarioId"] == null) {
      throw new runtime.RequiredError(
        "scenarioId",
        'Required parameter "scenarioId" was null or undefined when calling deleteScenario().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/{scenarioId}`.replace(
          `{${"scenarioId"}}`,
          encodeURIComponent(String(requestParameters["scenarioId"])),
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteScenario(
    requestParameters: DeleteScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteScenarioRaw(requestParameters, initOverrides);
  }

  /**
   */
  async exportDataRaw(
    requestParameters: ExportDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ExportQuoteGroupData>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling exportData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/export-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExportQuoteGroupDataFromJSON(jsonValue),
    );
  }

  /**
   */
  async exportData(
    requestParameters: ExportDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ExportQuoteGroupData> {
    const response = await this.exportDataRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllGroupsRaw(
    requestParameters: GetAllGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<QuoteTestGroupDto>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getAllGroups().',
      );
    }

    if (requestParameters["serviceIdentifier"] == null) {
      throw new runtime.RequiredError(
        "serviceIdentifier",
        'Required parameter "serviceIdentifier" was null or undefined when calling getAllGroups().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["serviceIdentifier"] != null) {
      queryParameters["serviceIdentifier"] =
        requestParameters["serviceIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/groups`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(QuoteTestGroupDtoFromJSON),
    );
  }

  /**
   */
  async getAllGroups(
    requestParameters: GetAllGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<QuoteTestGroupDto>> {
    const response = await this.getAllGroupsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getBasicScenarioRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuoteTestScenario>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/basic-scenario`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QuoteTestScenarioFromJSON(jsonValue),
    );
  }

  /**
   */
  async getBasicScenario(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuoteTestScenario> {
    const response = await this.getBasicScenarioRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getScenarioRaw(
    requestParameters: GetScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuoteTestScenarioDetailsDto>> {
    if (requestParameters["scenarioId"] == null) {
      throw new runtime.RequiredError(
        "scenarioId",
        'Required parameter "scenarioId" was null or undefined when calling getScenario().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/{scenarioId}`.replace(
          `{${"scenarioId"}}`,
          encodeURIComponent(String(requestParameters["scenarioId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QuoteTestScenarioDetailsDtoFromJSON(jsonValue),
    );
  }

  /**
   */
  async getScenario(
    requestParameters: GetScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuoteTestScenarioDetailsDto> {
    const response = await this.getScenarioRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async importDataRaw(
    requestParameters: ImportDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["importQuoteGroupData"] == null) {
      throw new runtime.RequiredError(
        "importQuoteGroupData",
        'Required parameter "importQuoteGroupData" was null or undefined when calling importData().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/import-data`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ImportQuoteGroupDataToJSON(
          requestParameters["importQuoteGroupData"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async importData(
    requestParameters: ImportDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.importDataRaw(requestParameters, initOverrides);
  }

  /**
   */
  async runGroupRaw(
    requestParameters: RunGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["groupId"] == null) {
      throw new runtime.RequiredError(
        "groupId",
        'Required parameter "groupId" was null or undefined when calling runGroup().',
      );
    }

    if (requestParameters["executionType"] == null) {
      throw new runtime.RequiredError(
        "executionType",
        'Required parameter "executionType" was null or undefined when calling runGroup().',
      );
    }

    if (requestParameters["tags"] == null) {
      throw new runtime.RequiredError(
        "tags",
        'Required parameter "tags" was null or undefined when calling runGroup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["groupId"] != null) {
      queryParameters["groupId"] = requestParameters["groupId"];
    }

    if (requestParameters["executionType"] != null) {
      queryParameters["executionType"] = requestParameters["executionType"];
    }

    if (requestParameters["tags"] != null) {
      queryParameters["tags"] = requestParameters["tags"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/run-group`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async runGroup(
    requestParameters: RunGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.runGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async runScenarioRaw(
    requestParameters: RunScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["scenarioId"] == null) {
      throw new runtime.RequiredError(
        "scenarioId",
        'Required parameter "scenarioId" was null or undefined when calling runScenario().',
      );
    }

    if (requestParameters["executionType"] == null) {
      throw new runtime.RequiredError(
        "executionType",
        'Required parameter "executionType" was null or undefined when calling runScenario().',
      );
    }

    if (requestParameters["tags"] == null) {
      throw new runtime.RequiredError(
        "tags",
        'Required parameter "tags" was null or undefined when calling runScenario().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["executionType"] != null) {
      queryParameters["executionType"] = requestParameters["executionType"];
    }

    if (requestParameters["tags"] != null) {
      queryParameters["tags"] = requestParameters["tags"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/quote-test/scenarios/{scenarioId}/runs`.replace(
          `{${"scenarioId"}}`,
          encodeURIComponent(String(requestParameters["scenarioId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async runScenario(
    requestParameters: RunScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.runScenarioRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateCommentRaw(
    requestParameters: UpdateCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["quoteTestExecutionComment"] == null) {
      throw new runtime.RequiredError(
        "quoteTestExecutionComment",
        'Required parameter "quoteTestExecutionComment" was null or undefined when calling updateComment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/comments`,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: QuoteTestExecutionCommentToJSON(
          requestParameters["quoteTestExecutionComment"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateComment(
    requestParameters: UpdateCommentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCommentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateGroupRaw(
    requestParameters: UpdateGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["quoteTestGroup"] == null) {
      throw new runtime.RequiredError(
        "quoteTestGroup",
        'Required parameter "quoteTestGroup" was null or undefined when calling updateGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/update-group`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: QuoteTestGroupToJSON(requestParameters["quoteTestGroup"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateGroup(
    requestParameters: UpdateGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateGroupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateScenarioRaw(
    requestParameters: UpdateScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["quoteTestScenario"] == null) {
      throw new runtime.RequiredError(
        "quoteTestScenario",
        'Required parameter "quoteTestScenario" was null or undefined when calling updateScenario().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/update-scenario`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: QuoteTestScenarioToJSON(requestParameters["quoteTestScenario"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateScenario(
    requestParameters: UpdateScenarioRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateScenarioRaw(requestParameters, initOverrides);
  }

  /**
   */
  async xmlToJsonRaw(
    requestParameters: XmlToJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<XmlToJson>> {
    if (requestParameters["postXmlToJson"] == null) {
      throw new runtime.RequiredError(
        "postXmlToJson",
        'Required parameter "postXmlToJson" was null or undefined when calling xmlToJson().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/quote-test/xml-to-json`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostXmlToJsonToJSON(requestParameters["postXmlToJson"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      XmlToJsonFromJSON(jsonValue),
    );
  }

  /**
   */
  async xmlToJson(
    requestParameters: XmlToJsonRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<XmlToJson> {
    const response = await this.xmlToJsonRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
